import React from "react";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import "./style.css";
export default function CategoryDescription(props) {
    return (React.createElement("div", { className: "category-description-container" },
        React.createElement(PlainEditor, { label: "", onChange: () => { }, editable: false, example: props.text })));
}
